export const initRollingText = () => {
    const toggleButtons = document.querySelectorAll<HTMLButtonElement>(
        '[data-selector="rolling-text-toggle"]',
    );

    toggleButtons.forEach((toggleButton) => {
        toggleButton.addEventListener("click", (event) => {
            const button = event.currentTarget as HTMLButtonElement;
            const targetId = button.getAttribute("data-target");
            const target = document.querySelector<HTMLElement>(`#${targetId}`)!;
            const currentState = target.dataset.state;
            const isPaused = currentState === "paused";

            target.dataset.state = isPaused ? "running" : "paused";
            button.textContent = button.getAttribute(
                isPaused ? "data-pause-label" : "data-play-label",
            )!;
        });
    });
};
